'use strict';

var _ = require('lodash');

function ListController ($scope) {

  var DEFAULTS = {
    categories: false,
    categoryItemsKey: 'list',
    categoryTemplateUrl: 'saturn/list/listCategory.tpl.html',
    list: {},
    filterCategoryBy: '',
    filterItemBy: '',
    itemTemplateUrl: 'saturn/list/listItem.tpl.html',
    itemClassFn: function() { },
    multiselect: false,
    parentController: null,
    parentControllerAs: '',
    selected: {}
  };

  var counter = 0;

  /**
   * Initializes the controller. Triggered by the directive link function.
   */
  this.init = function () {
    _.defaults(this, DEFAULTS);

    bindParentControllerToScope();

    this.categories = (/true/i).test(this.categories);
    this.multiselect = (/true/i).test(this.multiselect);
  };

  /**
   * Triggered when an element is clicked
   *
   * @param  {Object} item the list item data
   * @param  {Number} index the numerical index of the list item
   * @param  {Object} [category] the category the item belongs to
   */
  this.click = function (e, item, index, category) {
    var isSelected = this.isSelected(item, index);

    if (isSelected) {
      removeSelected(item, index, category);
    } else {
      setSelected(item, index, category);
    }

    $scope.$emit('list:clickedItem', {
      item: item,
      category: category
    });

    e.stopPropagation();
  };

  this.getCategoryItems = function (category) {
    var key = this.categoryItemsKey;
    return category[key];
  };

  /**
   * Used by the template to figure out if the current item should be selected or not
   * Currently assumes that all items will have an 'id' property, and uses that to determine
   * selection state. Depending on necessary flexibility it may make sense for this function
   * to be set as a directive attribute.
   *
   * @param  {Object} item the list item data
   * @param  {Number} index the numerical index of the list item
   * @param  {Object} [category] the category the item belongs to
   * @return {Boolean} true is selected, false if not
   */
  this.isSelected = function (item) {
    var id = getListItemId(item);
    return this.selected && !!this.selected[id];
  };

  ////////////////////////////////////////////////////////////////////////////////////////////
  // Helpers
  ////////////////////////////////////////////////////////////////////////////////////////////

  /**
   * Make external controller available as "controllerAs" name for item/category.
   * This is necessary because list and everything inside is an isolate scope.
   */
  var bindParentControllerToScope = function () {
    var key = this.parentControllerAs;

    if (!this.parentController) {
      return;
    }

    if ($scope[key]) {
      throw new Error('Key ' + key + ' already in use.');
    } else {
      $scope[key] = this.parentController;
    }
  }.bind(this);

  /**
   * Used internally to retrieve a specified controller attribute
   *
   * @param  {String} key
   * @return {*}
   */
  var ctrlAttr = function (key) {
    return function () {
      return this[key];
    }.bind(this);
  }.bind(this);

  /**
   * Retrieves the list item id. This is used to track the 'selected' items.
   * Uses the items 'id' attribute if available, otherwise constructs its own and saves it to the item.
   *
   * @param  {Object} item the list item data
   * @return {String} id
   */
  var getListItemId = function (item) {
    var id = item.id || item.$$listItemId;

    if (!id) {
      id = 'listItemId' + counter++;
    }

    item.$$listItemId = id;

    return id;
  };

  /**
   * Used internally to remove a selected item
   *
   * @param  {Object} item the list item data
   * @param  {Number} index the numerical index of the list item
   * @param  {Object} [category] the category the item belongs to
   */
  var removeSelected = function (item, index, category) {
    var id = getListItemId(item);

    delete this.selected[id];

    $scope.$emit('list:deselectedItem', {
      item: item,
      category: category
    });
  }.bind(this);

  /**
   * Used internally to set the selected item
   *
   * @param  {Object} item the list item data
   * @param  {Number} index the numerical index of the list item
   * @param  {Object} [category] the category the item belongs to
   */
  var setSelected = function (item, index, category) {
    var id = getListItemId(item);
    var multiselect = this.multiselect;

    // remove all other selected items
    if (!multiselect) {
      _.forEach(this.selected, function (item, itemId) {
        if (itemId !== id) {
          removeSelected(item, itemId);
        }
      });
    }

    this.selected[id] = item;

    $scope.$emit('list:selectedItem', {
      item: item,
      category: category
    });
  }.bind(this);

  ////////////////////////////////////////////////////////////////////////////////////////////
  // Event Handlers
  ////////////////////////////////////////////////////////////////////////////////////////////

  /**
   * Handles changes by the outer scope to the bound selected object and reassigns it if needed
   */
  var onSelectedChange = function (newVal, oldVal) {
    if (newVal && newVal !== oldVal) {
      this.selected = newVal;
    }
  }.bind(this);

  // Not sure this is necessary anymore with bindToController
  $scope.$watch(ctrlAttr('selected'), onSelectedChange);
}

module.exports = ListController;


// WEBPACK FOOTER //
// ./~/@skycatch/skydash-saturn/boosters/list/src/ListController.js